import { OfficeLocation } from "@/api/locations";
import {
  Autocomplete,
  AutocompleteItem,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { useCallback, useEffect, useState } from "react";

export function PromptAddressModal({
  disclosure,
  data,
  addresses,
  onConfirm,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  data: Partial<OfficeLocation>;
  addresses: string[];
  onConfirm: (data: Partial<OfficeLocation>) => void;
}) {
  const { isOpen, onOpenChange } = disclosure;

  const [customAddress, setCustomAddress] = useState<string>(
    data.address || "",
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(false);
  }, [isOpen]);

  const onConfirmAddress = useCallback(() => {
    onConfirm({
      ...data,
      address: customAddress,
    });
  }, [data, customAddress, onConfirm]);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="Подтверждение адреса"
      className="z-[999999999999]"
      isDismissable={false}
      backdrop="blur"
    >
      <ModalContent>
        {() => (
          <>
            <ModalHeader>
              <span className="text-lg font-bold">Подтверждение адреса</span>
            </ModalHeader>
            <ModalBody>
              <div className="flex flex-col gap-2">
                <Autocomplete
                  items={addresses.map((address) => ({ label: address }))}
                  value={customAddress}
                  onSelectionChange={(value) =>
                    setCustomAddress(value?.toString() || "")
                  }
                  variant="bordered"
                  size="lg"
                  placeholder="Введите адрес"
                >
                  {(item) => (
                    <AutocompleteItem key={item.label}>
                      {item.label}
                    </AutocompleteItem>
                  )}
                </Autocomplete>
              </div>
            </ModalBody>
            <ModalFooter className="flex flex-row justify-between">
              <Button
                isLoading={isLoading}
                color="default"
                variant="flat"
                onPress={onConfirmAddress}
              >
                Тут нет нужного адреса
              </Button>
              <Button
                isLoading={isLoading}
                color="success"
                variant="flat"
                onPress={onConfirmAddress}
              >
                Подтвердить
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
